import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Spin, Tabs } from 'antd';
import type { RMAssetFormType } from 'pos-shared/models/resourceManagementSchema.ts';

import AvailabilityTabContent from './AvailabilityTabContent.tsx';
import BasicDetailsTabContent from './BasicDetailsTabContent.tsx';
import CapacityTabContent from './CapacityTabContent.tsx';
import RechargeSettingsTabContent from './RechargeSettingsTabContent.tsx';

interface RouteDetailsProps {
  control: Control<RMAssetFormType>;
  formValues: RMAssetFormType;
  isLoading: boolean;
}

const RouteDetailsTabContent = ({
  control,
  formValues,
  isLoading,
}: RouteDetailsProps) => {
  const { t } = useTranslation();

  if (isLoading) return <Spin />;

  return (
    <Tabs
      defaultActiveKey="1"
      items={[
        {
          label: t('common.contact.basicDetails'),
          key: '1',
          children: <BasicDetailsTabContent control={control} />,
        },
        {
          label: t('scheduling.availability.availability'),
          key: '2',
          children: <AvailabilityTabContent control={control} />,
        },
        {
          label: t('routes.rechargeSettings.rechargeSettings'),
          key: '3',
          children: <RechargeSettingsTabContent control={control} />,
        },
        {
          label: t('routes.capacity'),
          key: '4',
          children: (
            <CapacityTabContent formValues={formValues} control={control} />
          ),
        },
      ]}
    />
  );
};

export default RouteDetailsTabContent;
